module.exports = __webpack_public_path__ + "img/popup_battery_0.d52d2a61.svg";